import { createUniqueId } from 'solid-js'

export function DailyChallengeRewardIcon() {
  // Minted per instance, so copies of one icon never resolve url(#…) to
  // each other's defs
  const id = createUniqueId()
  const paint0 = `daily-challenge-reward-icon-${id}-paint0`
  const paint1 = `daily-challenge-reward-icon-${id}-paint1`

  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M16.4552 40.115C13.2352 40.115 10.6052 37.495 10.6052 34.265C10.6052 32.245 11.6352 30.465 13.1852 29.415C12.8552 29.115 12.5452 28.805 12.2452 28.475C7.36524 27.905 3.55524 23.745 3.55524 18.705V15.265C3.55524 11.985 5.99524 9.27501 9.14524 8.83501C10.2852 7.03501 12.2852 5.88501 14.5452 5.88501H31.5452C33.8052 5.88501 35.8152 7.04501 36.9552 8.85501C40.0552 9.34501 42.4352 12.025 42.4352 15.265V18.705C42.4352 23.705 38.6952 27.845 33.8552 28.465C33.5452 28.795 33.2352 29.115 32.8952 29.415C34.4552 30.465 35.4852 32.245 35.4852 34.265C35.4852 37.485 32.8652 40.115 29.6352 40.115H16.4352H16.4552Z"
        fill="#56ED16"
      />
      <path d="M26 27H20V34H26V27Z" fill="#016F2B" />
      <path
        d="M29.2843 32H16.7157C15.2159 32 14 33.1193 14 34.5C14 35.8807 15.2159 37 16.7157 37H29.2843C30.7841 37 32 35.8807 32 34.5C32 33.1193 30.7841 32 29.2843 32Z"
        fill="#016F2B"
      />
      <path
        d="M32.5952 25.5451H13.3952C9.62524 25.5451 6.55524 22.4751 6.55524 18.7051V15.2651C6.55524 13.3451 8.11524 11.7751 10.0452 11.7751H35.9652C37.8852 11.7751 39.4552 13.3351 39.4552 15.2651V18.7051C39.4552 22.4751 36.3852 25.5451 32.6152 25.5451H32.5952ZM10.0452 14.7751C9.77524 14.7751 9.55524 14.9951 9.55524 15.2651V18.7051C9.55524 20.8251 11.2752 22.5451 13.3952 22.5451H32.5952C34.7152 22.5451 36.4352 20.8251 36.4352 18.7051V15.2651C36.4352 14.9951 36.2152 14.7751 35.9452 14.7751H10.0452Z"
        fill={`url(#${paint0})`}
      />
      <path
        d="M34.9753 17.935C34.9753 24.735 29.6353 30.255 23.0553 30.255C16.4753 30.255 11.1353 24.735 11.1353 17.935C11.1353 17.775 11.1353 14.815 11.1353 12.315C11.1353 10.415 12.6653 8.88501 14.5553 8.88501C19.0853 8.88501 27.0253 8.88501 31.5553 8.88501C33.4553 8.88501 34.9853 10.415 34.9753 12.315C34.9753 14.805 34.9753 17.775 34.9753 17.935Z"
        fill={`url(#${paint1})`}
      />
      <path
        d="M26.2768 17.7469L24.0434 15.5135C23.4977 14.9678 22.6129 14.9678 22.0672 15.5135L19.8338 17.7469C19.2881 18.2926 19.2881 19.1774 19.8338 19.7232L22.0672 21.9565C22.6129 22.5023 23.4977 22.5023 24.0434 21.9565L26.2768 19.7232C26.8225 19.1774 26.8225 18.2926 26.2768 17.7469Z"
        fill="#75FF0D"
      />
      <path
        d="M41.255 33.0001L41.975 32.2801C43.795 30.4601 43.795 27.5101 41.975 25.7001C41.095 24.8201 39.925 24.3401 38.685 24.3401C37.445 24.3401 36.275 24.8201 35.395 25.7001L34.675 26.4201L33.955 25.7001C33.075 24.8201 31.905 24.3401 30.665 24.3401C29.425 24.3401 28.245 24.8101 27.365 25.6901C25.555 27.5101 25.555 30.4601 27.365 32.2801L28.085 33.0001L27.365 33.7201C25.545 35.5401 25.545 38.4901 27.365 40.3001C28.245 41.1801 29.415 41.6601 30.655 41.6601C31.895 41.6601 33.065 41.1801 33.945 40.3001L34.665 39.5801L35.385 40.3001C36.265 41.1801 37.435 41.6601 38.675 41.6601C39.915 41.6601 41.085 41.1801 41.965 40.3001C43.785 38.4801 43.785 35.5301 41.965 33.7201L41.245 33.0001H41.255Z"
        fill="white"
      />
      <path
        d="M37.665 33.0002L40.185 30.4802C41.015 29.6502 41.015 28.3102 40.185 27.4902C39.355 26.6702 38.015 26.6602 37.195 27.4902L34.675 30.0102L32.155 27.4902C31.325 26.6602 29.985 26.6602 29.165 27.4902C28.345 28.3202 28.335 29.6602 29.165 30.4802L31.685 33.0002L29.165 35.5202C28.335 36.3502 28.335 37.6902 29.165 38.5102C29.575 38.9202 30.115 39.1302 30.665 39.1302C31.215 39.1302 31.745 38.9202 32.165 38.5102L34.685 35.9902L37.205 38.5102C37.615 38.9202 38.155 39.1302 38.705 39.1302C39.255 39.1302 39.785 38.9202 40.205 38.5102C41.035 37.6802 41.035 36.3402 40.205 35.5202L37.685 33.0002H37.665Z"
        fill="#FF3F6F"
      />
      <defs>
        <linearGradient
          id={paint0}
          x1="23.0052"
          y1="5.38501"
          x2="23.0052"
          y2="25.885"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#01B311" />
          <stop offset="1" stop-color="#01642F" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="23.0553"
          y1="8.88501"
          x2="23.0553"
          y2="27.385"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00BF0E" />
          <stop offset="1" stop-color="#007D3A" />
        </linearGradient>
      </defs>
    </svg>
  )
}
